import type { FC } from 'react';

import { NotificationInline } from '@coop/components';

import styles from './EditOrderModeNotice.module.scss';

export interface EditOrderModeNoticeProps {
    heading: string;
}

export const EditOrderModeNotice: FC<React.PropsWithChildren<EditOrderModeNoticeProps>> = (
    props,
) => {
    return (
        <NotificationInline show animated={false} variant="warning" role="status">
            <div className={styles.Notice}>
                <div className={styles.Heading}>{props.heading}</div>
                {props.children && <div className={styles.SubHeading}>{props.children}</div>}
            </div>
        </NotificationInline>
    );
};
